import { mapTileUrlList } from '../mapTileUrlList';

export function currentTileLayerMessageSetter(currentTileUrl: string) {
    switch (currentTileUrl) {
        case mapTileUrlList.googleMapsHybrid:
            return 1;
        case mapTileUrlList.googleMapsSatellite:
            return 2;
        case mapTileUrlList.googleMapsRoads:
            return 3;
        case mapTileUrlList.arcGIS:
            return 4;
        case mapTileUrlList.openStreetMap:
            return 5;
        case mapTileUrlList.openStreetMap2:
            return 6;
        case mapTileUrlList.thunderForestTopography:
            return 7;
        case mapTileUrlList.topographyMap:
            return 8;
        case mapTileUrlList.stadiaMap:
            return 9;
        case mapTileUrlList.wikiMediaMap:
            return 10;
        // case mapTileUrlList.bingMapSatellite:
        //     return 11;
    }
}
